import {
	fireClearCodeEvent,
	fireInsertCharacterEvent,
	fireInsertWordEvent,
} from "../editor/events";

import type { MaskStylesObj } from "@reactour/mask";
import type { PopoverStylesObj } from "@reactour/popover";
import type { StylesObj } from "@reactour/tour";
import { colors } from "@quickpoint.me/shared";

let typer: NodeJS.Timeout;

const typeSpeed = process.env.NODE_ENV === "test" ? 1 : 50;
export function typeSomeText({
	text,
	prefill,
	openAutoComplete = false,
}: { text: string; prefill?: string; openAutoComplete?: boolean }) {
	clearInterval(typer);
	const characters = Array.from(text);
	let idx = 0;

	if (prefill) {
		fireClearCodeEvent();
		fireInsertWordEvent({ word: prefill, insertAtLineNumber: false });
	}

	if (characters.length === 0) {
		window.dispatchEvent(new CustomEvent("typingComplete"));
		return;
	}

	typer = setInterval(() => {
		if (!characters[idx]) {
			window.dispatchEvent(new CustomEvent("typingComplete"));
			clearInterval(typer);
			return;
		}
		fireInsertCharacterEvent(characters[idx], openAutoComplete);
		idx++;
	}, typeSpeed);
}

export const qpTourStyles: StylesObj | PopoverStylesObj | MaskStylesObj = {
	close: (base) => ({
		...base,
		color: colors.tufte.red,
		// 44px tap target (WCAG 2.5.5 / iOS): 16px visual ✕ + padding.
		// content-box so the app's border-box reset can't eat the padding
		right: "0",
		top: "0",
		width: "16px",
		height: "16px",
		minWidth: "16px",
		minHeight: "16px",
		padding: "14px",
		boxSizing: "content-box",
	}),
	// prev/next arrows: reactour's default is a bare 16x12 svg in an
	// unpadded button — untappable on phones. Pad the buttons to 44px.
	button: (base) => ({
		...base,
		minWidth: "44px",
		minHeight: "44px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		boxSizing: "border-box",
	}),
	arrow: (base, state) => ({
		...base,
		width: 22,
		height: 18,
		flex: "0 0 22px",
		color: (state as { disabled?: boolean } | undefined)?.disabled
			? "#caccce"
			: "#333333",
	}),
	maskWrapper: (base) => ({ ...base, opacity: 0.3 }),
	popover: (base) => ({
		...base,
		"--reactour-accent": colors.tufte.black,
		background: colors.tufte.white,
		color: colors.tufte.black,
		fontFamily: "Gill Sans",
		border: `2px solid ${colors.tufte.black}`,
		borderRadius: "5px",
	}),
	badge: (base) => ({
		...base,
		background: colors.tufte.white,
		color: colors.tufte.black,
	}),
	dot: (base) => ({ ...base }),
};
